import { differenceInYears, format, parseISO } from 'date-fns';

export const formatDateFront = (date) => {
  if (!date) return 'Non spécifié';
  return format(date, 'dd/MM/yyyy');
};

export const getAgeFromDateString = (dateString) => {
  if(!dateString) return 0;
  const birthDate = parseISO(dateString);
  const today = new Date();
  return differenceInYears(today, birthDate);
};

export const handleResponse = (response) => {
  if (response.data.error) {
    throw new Error(response.data.message || 'Unknown API error');
  }
  return response.data.data;
};

export const handlePromise = async (promise) => {
  const response = await promise;
  if (response.data.error) {
    throw new Error(response.data.message || 'Unknown API error');
  }
  return response.data.data;
};

export const requiredField = 'Veuillez remplir ce champ';
